import React, { useState } from 'react';
import ButtonComponent from 'components/ButtonComponent';
import useManual from './useManual';
import DownloadManual from 'components/DownloadManual';

const OnlineOrdersManual = () => {
    const [newConfigFile, setNewConfigFile] = useState<File | null>(null);
    const { manualExists, isLoading, statusMessage, uploadManual } = useManual();

    const handleConfigFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = event.target;
        setNewConfigFile(files && files.length === 1 ? files[0] : null);
    };

    return (
        <>
            <DownloadManual />
            <h2>Zastąp instrukcję obsługi zamówień online</h2>
            <div>
                <input type='file' accept='application/pdf' onChange={handleConfigFileChange} />
                <ButtonComponent
                    text='Zastąp instrukcję'
                    onClick={() => uploadManual(newConfigFile)}
                    variant='primary'
                    margin='0.25rem'
                    height='37px'
                    onHoverAnimation={3}
                    disabled={isLoading}
                />
                <p>&nbsp; {statusMessage}</p>
            </div>
            {manualExists && (
                <p>Instrukcja jest dostępna dla użytkowników.</p>
            )}
        </>
    );
};

export default OnlineOrdersManual;
